module.exports = __webpack_public_path__ + "img/gravier_marbre_blanc_rose.6d6e617f.jpg";